import React from 'react';
import RSSFeed from 'components/RSSFeed/RSSFeed';
import ModuleHeaderLayout from 'components/Common/Layouts/ModuleHeaderLayout';

export const IndustryUpdates: React.FC = () => {
  return (
    <ModuleHeaderLayout title='Industry News Updates' helpContent={''}>
      <RSSFeed />
    </ModuleHeaderLayout>
  );
};

export default IndustryUpdates;
